import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import Overlay from 'components/Overlay';
import { BodyDisableScroll } from 'components/BodyTag';
import { XMarkIcon } from 'components/Svg';
import { ButtonList, XIconButton, IconButtonList } from 'components/Button';


export const SidePanelHeader = ({ className, ...props }) => (
  <div className="side-panel-header" {...props } />
)

export const SidePanelTitle = ({ className, ...props }) => (
  <div className="side-panel-title" {...props } />
)

export const SidePanelActions = ({ className, ...props }) => <div className="side-panel-actions" {...props} />

export const SidePanelBody = ({ className, ...props }) => <div className="side-panel-body" {...props } />

export const SidePanelOverlay = ({className,...props}) => <div className={cx('g-side-panel-overlay', className)} {...props} />

export const SidePanelPopup = ({title, children, className, show, onClose,...props}) => (
  <div className={cx('g-side-panel-popup', className, {show: show, hide: !show})} {...props}>
    <SidePanel>
      {title && 
      <SidePanelHeader onClick={onClose}>
        <SidePanelTitle>{title}</SidePanelTitle>
        <IconButtonList>
          <XIconButton size="s" />
        </IconButtonList>
      </SidePanelHeader>}
      <SidePanelBody>
        { children }
      </SidePanelBody>
    </SidePanel>
    <SidePanelOverlay onClick={onClose} />
  </div>
)

export const SidePanel = ({className,...props}) => <div className={cx('g-side-panel', className)} {...props} />

export const SidePanelOver = ({show, onHide, className,...props}) => {
  let onOverlayClick = () => onHide?.()
  return (<>
    <div className={cx('g-side-panel', 'over', className, { show, hide: !show })} {...props} />
    <Overlay onClick={onOverlayClick} show={show} />
    {show && 
    <BodyDisableScroll />}
  </>);
}
export default SidePanel;